export const ADD_TOASTR = "ADD_TOASTR";
export const LIST_TOASTR = "LIST_TOASTR";
export const REMOVE_TOASTR = "REMOVE_TOASTR";

